// extracted by css-extract-rspack-plugin
module.exports =  {"loading":"List__loading___HKznP"};